module.exports = __webpack_public_path__ + "img/83288e3.png";